module.exports = function() {
  return new Worker(__webpack_public_path__ + "b8aec4c2bf812135a171.worker.js");
};